var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0156 8.16651C20.0346 8.16574 21.0396 8.40261 21.951 8.85829C22.8623 9.31397 23.6549 9.9759 24.2656 10.7915",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 10.7915C1.90762 9.9759 2.70016 9.31397 3.61152 8.85829C4.52287 8.40261 5.52794 8.16574 6.54688 8.16651",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.6665C14.3289 11.6665 15.4062 10.5892 15.4062 9.26025C15.4062 7.93132 14.3289 6.854 13 6.854C11.6711 6.854 10.5938 7.93132 10.5938 9.26025C10.5938 10.5892 11.6711 11.6665 13 11.6665Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60938 13.5259C9.95148 12.9596 10.4392 12.4902 11.0242 12.1641C11.6093 11.838 12.2715 11.6665 12.9453 11.6665C13.6192 11.6665 14.2813 11.838 14.8664 12.1641C15.4515 12.4902 15.9391 12.9596 16.2812 13.5259",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 3.7915C15.7886 3.15775 16.1267 2.58257 16.6008 2.1313C17.0749 1.68004 17.6661 1.37076 18.3072 1.2386C18.9482 1.10643 19.6135 1.15668 20.2274 1.38363C20.8414 1.61058 21.3794 2.00514 21.7803 2.5225C22.1813 3.03986 22.4291 3.65929 22.4957 4.31044C22.5623 4.96159 22.445 5.61836 22.157 6.20617C21.8691 6.79398 21.4221 7.28926 20.8668 7.63579C20.3115 7.98231 19.6702 8.16617 19.0156 8.1665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54511 8.1665C5.89057 8.16617 5.24923 7.98231 4.69394 7.63579C4.13865 7.28926 3.69165 6.79398 3.40372 6.20617C3.11578 5.61836 2.99845 4.96159 3.06504 4.31044C3.13162 3.65929 3.37947 3.03986 3.78042 2.5225C4.18138 2.00514 4.71937 1.61058 5.33331 1.38363C5.94725 1.15668 6.61253 1.10643 7.25359 1.2386C7.89465 1.37076 8.4858 1.68004 8.95992 2.1313C9.43403 2.58257 9.7721 3.15775 9.93574 3.7915",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.fb9dc0ce999cb359d0880dd973829a3b.svg";
export { ForwardRef as ReactComponent };